(function () {
  const TRANSITION_DURATION = 300;

  function closeAccordion(details) {
    const content = details.querySelector('.accordion__content');
    if (!content) return;

    // Pin current height explicitly before animating to 0
    content.style.maxHeight = content.scrollHeight + 'px';
    content.getBoundingClientRect(); // force reflow

    content.style.maxHeight = '0px';

    setTimeout(() => {
      details.removeAttribute('open');
    }, TRANSITION_DURATION);
  }

  function openAccordion(details) {
    const content = details.querySelector('.accordion__content');
    if (!content) return;

    details.setAttribute('open', '');
    content.style.maxHeight = '0px';
    content.getBoundingClientRect(); // force reflow

    // Animate to full height
    content.style.maxHeight = content.scrollHeight + 'px';

    setTimeout(() => {
      // Clear inline max-height so content can resize freely (e.g. nested accordions)
      content.style.maxHeight = 'none';
    }, TRANSITION_DURATION);
  }

  function closeOtherAccordions(clickedDetails) {
    const parent = clickedDetails.closest(
      '.collapsible-content__grid, .product__description, [data-accordion-group]'
    );
    if (!parent) return;

    parent.querySelectorAll('.accordion details[open]').forEach((openDetails) => {
      if (openDetails !== clickedDetails) {
        closeAccordion(openDetails);
      }
    });
  }

  function initAccordions(root) {
    root.querySelectorAll('.accordion details').forEach((details) => {
      if (details.dataset.animationBound) return;
      details.dataset.animationBound = 'true';

      const summary = details.querySelector('summary');
      const content = details.querySelector('.accordion__content');
      if (!summary || !content) return;

      // Set initial state
      content.style.maxHeight = details.open ? 'none' : '0px';

      summary.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopImmediatePropagation();

        if (details.open) {
          closeAccordion(details);
        } else {
          closeOtherAccordions(details);
          openAccordion(details);
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', () => initAccordions(document));
  document.addEventListener('shopify:section:load', (e) => initAccordions(e.target));
})();
